<!-- 电能数据 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        v-loading="queryDeviceLoading"
        element-loading-text="正在获取设备列表"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="meter-powerdata"
        shadow="never"
      >
        <template slot="header">
          <el-form :model="queryParams" :inline="true" size="small">
            <el-form-item>
              <el-button-group>
                <el-button
                  :type="queryParams.ispositive === '1' ? 'primary' : ''"
                  @click="handlePositiveChange('1')"
                >正向冻结电量</el-button>
                <el-button
                  :type="queryParams.ispositive === '0' ? 'primary' : ''"
                  @click="handlePositiveChange('0')"
                >反向冻结电量</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button
                  v-for="item in dateTypeOptions"
                  :key="item.value"
                  :type="queryParams.dateType === item.value ? 'primary' : ''"
                  @click="queryParams.dateType = item.value"
                >{{ $t(item.labelEntry) }}</el-button>
              </el-button-group>
            </el-form-item>
            <template>
              <el-form-item label="开始时间">
                <el-date-picker v-show="queryParams.dateType === 'day'" v-model="queryParams.starttime" type="date" />
                <el-date-picker v-show="queryParams.dateType === 'month'" v-model="queryParams.starttime" type="month" />
                <el-date-picker v-show="queryParams.dateType === 'year'" v-model="queryParams.starttime" type="year" />
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker v-show="queryParams.dateType === 'day'" v-model="queryParams.endtime" type="date" />
                <el-date-picker v-show="queryParams.dateType === 'month'" v-model="queryParams.endtime" type="month" />
                <el-date-picker v-show="queryParams.dateType === 'year'" v-model="queryParams.endtime" type="year" />
              </el-form-item>
            </template>
            <el-form-item label="设备选择">
              <el-select v-model="queryParams.deviceId" placeholder="">
                <el-option
                  v-for="(item, index) in deviceList"
                  :key="index"
                  :label="item.key"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="是否乘倍率">
              <el-select v-model="queryParams.isori" placeholder="">
                <el-option
                  label="乘以倍率"
                  value="0"
                />
                <el-option
                  label="不乘以倍率"
                  value="1"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                v-if="queryDeviceSuccess"
                type="primary"
                :loading="queryLoading"
                @click="getOverviewData"
              >查询</el-button>
              <el-button
                v-if="queryDeviceSuccess"
                type="primary"
                :disabled="!canExportDetail"
                :loading="exportDetailLoading || queryLoading"
                @click="handleExportDataExcel"
              >导出</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div
            v-loading="queryLoading"
            class="content-container"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <div class="statistic-container">
              <el-statistic
                :precision="2"
                :title="`总${statisticResult.title}`"
                :suffix="statisticResult.unit"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.totalValue) }}
                </template>
              </el-statistic>
              <el-statistic
                :precision="2"
                :value="statisticResult.sharpValue"
                :title="`尖${statisticResult.title}`"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.sharpValue) }}
                </template>
              </el-statistic>
              <el-statistic
                :precision="2"
                :value="statisticResult.peakValue"
                :title="`峰${statisticResult.title}`"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.peakValue) }}
                </template>
              </el-statistic>
              <el-statistic
                :precision="2"
                :value="statisticResult.flatValue"
                :title="`平${statisticResult.title}`"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.flatValue) }}
                </template>
              </el-statistic>
              <el-statistic
                :precision="2"
                :value="statisticResult.valleyValue"
                :title="`谷${statisticResult.title}`"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.valleyValue) }}
                </template>
              </el-statistic>
              <el-statistic
                :precision="2"
                :value="statisticResult.deepValleyValue"
                :title="`深谷${statisticResult.title}`"
              >
                <template slot="formatter">
                  {{ statisticResultFormat(statisticResult.deepValleyValue) }}
                </template>
              </el-statistic>
            </div>
            <div class="result-container">
              <div ref="chartContainer" class="chart-container" />
              <div class="table-container">
                <el-table :data="tableData" height="100%">
                  <el-table-column prop="date" label="日期" />
                  <el-table-column prop="ori" label="读数" />
                  <el-table-column prop="sharp" label="尖电量" />
                  <el-table-column prop="peak" label="峰电量" />
                  <el-table-column prop="flat" label="平电量" />
                  <el-table-column prop="valley" label="谷电量" />
                  <el-table-column prop="deepValley" label="深谷电量" />
                  <el-table-column prop="total" label="总电量" />
                </el-table>
              </div>
            </div>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { DMYEnergys, ExportDMYEnergys } from '@/api/Meter'
import { GetDevicesByOrgId } from '@/api/Universal'
import dayjs from 'dayjs'
import echarts from 'echarts'
export default {
  data () {
    return {
      /** 查询设备列表loading */
      queryDeviceLoading: false,
      /** 查询设备列表成功 */
      queryDeviceSuccess: false,
      /** 导出详情loading */
      exportDetailLoading: false,
      /** 是否可以导出详情 */
      canExportDetail: false,

      /** 设备列表 */
      deviceList: [],
      /** 日期类型选项 */
      dateTypeOptions: [
        { labelEntry: 'text.r', value: 'day', timeFormat: 'YYYY-MM-DD' },
        { labelEntry: 'text.y', value: 'month', timeFormat: 'YYYY-MM-01' },
        { labelEntry: 'text.n', value: 'year', timeFormat: 'YYYY-01-01' },
      ],

      /** 查询参数 */
      queryParams: {
        /** 日期类型 day/month/year */
        dateType: 'day',
        /** 开始时间 */
        starttime: dayjs().format('YYYY-MM-01'),
        /** 结束时间 */
        endtime: dayjs().format('YYYY-MM-DD'),
        /** 设备主键 */
        deviceId: null,
        /** 是否是原始数据, 0 不是, 1 是 */
        isori: '1',
        /** 是否正向  0:反向, 1:正向 */
        ispositive: '1',
      },
      /** 查询响应 */
      queryLoading: false,
      /** 查询响应数据 */
      queryResponse: {},

      /** 统计配置 */
      statisticResult: {
        /** 标题 */
        title: '电量',
        /** 单位 */
        unit: 'kWh',
        /** 尖电量 */
        sharpValue: '',
        /** 峰电量 */
        peakValue: '',
        /** 平电量 */
        flatValue: '',
        /** 谷电量 */
        valleyValue: '',
        /** 深谷电量 */
        deepValleyValue: '',
        /** 总电量 */
        totalValue: '',
      },
      /** 图表配置 */
      chartConfig: {
        /** 图表实例 */
        chartInstance: null,
        /** 图表配置 */
        chartOptions: {
          color: [],
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            top: 15,
            itemGap: 50,
            data: [
              { name: '尖', icon: 'circle', textStyle: { color: '#FFFFFF' }},
              { name: '峰', icon: 'circle', textStyle: { color: '#FFFFFF' }},
              { name: '平', icon: 'circle', textStyle: { color: '#FFFFFF' }},
              { name: '谷', icon: 'circle', textStyle: { color: '#FFFFFF' }},
              { name: '深谷', icon: 'circle', textStyle: { color: '#FFFFFF' }},
            ]
          },
          grid: {
            left: '60px',
            right: '15px',
            bottom: '20px',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [],
            axisLabel: {
              color: '#ffffff'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#ffffff'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: '尖',
              type: 'bar',
              stack: '总量',
              barMaxWidth: 30,
              data: []
            },
            {
              name: '峰',
              type: 'bar',
              stack: '总量',
              barMaxWidth: 30,
              data: []
            },
            {
              name: '平',
              type: 'bar',
              stack: '总量',
              barMaxWidth: 30,
              data: []
            },
            {
              name: '谷',
              type: 'bar',
              stack: '总量',
              barMaxWidth: 30,
              data: []
            },
            {
              name: '深谷',
              type: 'bar',
              stack: '总量',
              barMaxWidth: 30,
              data: []
            }
          ]
        },
        /** 无数据配置 */
        noDataOptions: {
          title: {
            text: '暂无数据',
            textStyle: {
              color: '#ffffff',
              fontSize: 14,
            },
            top: 'center',
            left: 'center'
          }
        }
      },
      /** 表格数据 */
      tableData: [],
    }
  },
  mounted () {
    this.getDeviceList().then(() => {
      this.getOverviewData()
    })
  },
  methods: {

    /** 统计结果格式化 */
    statisticResultFormat (value) {
      return value >= 0 ? `${value}` : 'N/A'
    },

    /** 校验查询参数 */
    checkQueryParams () {
      let result = true
      try {
        if (!this.queryParams.deviceId) {
          throw new Error('请选择设备')
        }
        if (!this.queryParams.starttime || !this.queryParams.endtime) {
          throw new Error('请选择时间范围')
        }
        const timeFormat = this.dateTypeOptions.find(item => item.value === this.queryParams.dateType).timeFormat
        const startTime = dayjs(this.queryParams.starttime).format(timeFormat)
        const endTime = dayjs(this.queryParams.endtime).format(timeFormat)
        if (dayjs(startTime).isAfter(dayjs(endTime))) {
          throw new Error('开始时间不能晚于结束时间')
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: 'warning'
        })
        result = false
      }
      return result
    },

    /** 获取设备列表下拉选项 */
    getDeviceList () {
      this.queryDeviceLoading = true
      return new Promise((resolve, reject) => {
        GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' })
          .then(({ data }) => {
            this.deviceList = data || []
            this.queryParams.deviceId = this.deviceList[0].value || null
            this.queryDeviceSuccess = true
            resolve()
          }).catch(() => {
            this.queryDeviceSuccess = false
            this.$message({
              message: '获取设备列表失败',
              type: 'error'
            })
            reject()
          }).finally(() => {
            this.queryDeviceLoading = false
          })
      })
    },

    /** 获取日月年数据 */
    getOverviewData () {
      if (this.checkQueryParams()) {
        const timeFormat = { day: 'YYYY-MM-DD', month: 'YYYY-MM-01', year: 'YYYY-01-01' }[this.queryParams.dateType]
        const postParams = {
          dateType: this.queryParams.dateType,
          startTime: dayjs(this.queryParams.starttime).format(timeFormat),
          endTime: dayjs(this.queryParams.endtime).format(timeFormat),
          isori: this.queryParams.isori,
          deviceId: this.queryParams.deviceId,
          ispositive: this.queryParams.ispositive
        }
        this.queryLoading = true
        DMYEnergys(postParams).then(({ data }) => {
          this.queryResponse = data || {}
        }).then(() => {
          const { datas } = this.queryResponse
          this.canExportDetail = datas && datas.length > 0
        }).then(() => {
          this.setStatisticResult()
        }).then(() => {
          this.setChartData()
        }).then(() => {
          this.setTableData()
        }).then(() => {
          this.queryLoading = false
        }).catch(() => {
          const dateType = this.dateTypeOptions.find(item => item.value === this.queryParams.dateType).labelEntry
          this.$message({
            message: `获取${dateType}数据失败`,
            type: 'error'
          })
          this.queryLoading = false
        })
      }
    },

    /** 处理正向反向切换 */
    handlePositiveChange (positive) {
      this.queryParams.ispositive = positive
      this.setStatisticResult()
      this.setChartData()
      this.setTableData()
    },

    /** 设置统计结果 */
    setStatisticResult () {
      const { fsharp, fpeak, fflat, fvalley, fdvalley, ftotal,
        rsharp, rpeak, rflat, rvalley, rdvalley, rtotal } = this.queryResponse.gpenergy
      this.statisticResult.sharpValue = this.queryParams.ispositive === '1' ? fsharp : rsharp
      this.statisticResult.peakValue = this.queryParams.ispositive === '1' ? fpeak : rpeak
      this.statisticResult.flatValue = this.queryParams.ispositive === '1' ? fflat : rflat
      this.statisticResult.valleyValue = this.queryParams.ispositive === '1' ? fvalley : rvalley
      this.statisticResult.deepValleyValue = this.queryParams.ispositive === '1' ? fdvalley : rdvalley
      this.statisticResult.totalValue = this.queryParams.ispositive === '1' ? ftotal : rtotal
      this.statisticResult.unit = this.statisticResult.totalValue >= 0 ? 'kWh' : ''
    },

    /** 设置图表数据 */
    setChartData () {
      if (!this.chartConfig.chartInstance) {
        this.chartConfig.chartInstance = echarts.init(this.$refs.chartContainer)
      }
      this.chartConfig.chartOptions.xAxis.data = []
      this.chartConfig.chartOptions.series[0].data = []
      this.chartConfig.chartOptions.series[1].data = []
      this.chartConfig.chartOptions.series[2].data = []
      this.chartConfig.chartOptions.series[3].data = []
      this.chartConfig.chartOptions.series[4].data = []
      const { datas } = this.queryResponse
      if (datas) {
        const style = getComputedStyle(document.querySelector('.meter-powerdata'))
        this.chartConfig.chartOptions.color = [
          style.getPropertyValue('--sharp-color'),
          style.getPropertyValue('--peak-color'),
          style.getPropertyValue('--flat-color'),
          style.getPropertyValue('--valley-color'),
          style.getPropertyValue('--deepValley-color')
        ]
        this.chartConfig.chartOptions.legend.data[0].textStyle.color = style.getPropertyValue('--sharp-color')
        this.chartConfig.chartOptions.legend.data[1].textStyle.color = style.getPropertyValue('--peak-color')
        this.chartConfig.chartOptions.legend.data[2].textStyle.color = style.getPropertyValue('--flat-color')
        this.chartConfig.chartOptions.legend.data[3].textStyle.color = style.getPropertyValue('--valley-color')
        this.chartConfig.chartOptions.legend.data[4].textStyle.color = style.getPropertyValue('--deepValley-color')

        if (this.queryParams.ispositive === '1') {
          for (const item of datas) {
            this.chartConfig.chartOptions.xAxis.data.push(dayjs(item.sitetime).format('YYYY-MM-DD'))
            this.chartConfig.chartOptions.series[0].data.push(item.fsharp)
            this.chartConfig.chartOptions.series[1].data.push(item.fpeak)
            this.chartConfig.chartOptions.series[2].data.push(item.fflat)
            this.chartConfig.chartOptions.series[3].data.push(item.fvalley)
            this.chartConfig.chartOptions.series[4].data.push(item.fdvalley)
          }
        } else {
          for (const item of datas) {
            this.chartConfig.chartOptions.xAxis.data.push(dayjs(item.sitetime).format('YYYY-MM-DD'))
            this.chartConfig.chartOptions.series[0].data.push(item.rsharp)
            this.chartConfig.chartOptions.series[1].data.push(item.rpeak)
            this.chartConfig.chartOptions.series[2].data.push(item.rflat)
            this.chartConfig.chartOptions.series[3].data.push(item.rvalley)
            this.chartConfig.chartOptions.series[4].data.push(item.rdvalley)
          }
        }
        this.chartConfig.chartInstance.setOption(this.chartConfig.chartOptions, true)
      } else {
        this.chartConfig.chartInstance.setOption(this.chartConfig.noDataOptions, true)
      }
    },

    /** 设置表格数据 */
    setTableData () {
      const timeFormat = { day: 'YYYY-MM-DD', month: 'YYYY-MM-01', year: 'YYYY-01-01' }[this.queryParams.dateType]
      const { datas } = this.queryResponse
      this.tableData = []
      if (datas) {
        if (this.queryParams.ispositive === '1') {
          this.tableData = datas.map(item => {
            return {
              ori: item.oriftotal,
              date: dayjs(item.sitetime).format(timeFormat),
              sharp: item.fsharp,
              peak: item.fpeak,
              flat: item.fflat,
              valley: item.fvalley,
              deepValley: item.fdvalley,
              total: item.ftotal,
            }
          })
        } else {
          this.tableData = datas.map(item => {
            return {
              ori: item.orirtotal,
              date: dayjs(item.sitetime).format(timeFormat),
              sharp: item.rsharp,
              peak: item.rpeak,
              flat: item.rflat,
              valley: item.rvalley,
              deepValley: item.rdvalley,
              total: item.rtotal,
            }
          })
        }
      }
    },

    /** 导出详情 */
    handleExportDataExcel () {
      const timeFormat = { day: 'YYYY-MM-DD', month: 'YYYY-MM-01', year: 'YYYY-01-01' }[this.queryParams.dateType]
      const postParams = {
        dateType: this.queryParams.dateType,
        startTime: dayjs(this.queryParams.starttime).format(timeFormat),
        endTime: dayjs(this.queryParams.endtime).format(timeFormat),
        isori: this.queryParams.isori,
        deviceId: this.queryParams.deviceId,
        ispositive: this.queryParams.ispositive
      }
      this.exportDetailLoading = true
      ExportDMYEnergys(postParams).then(res => {
        window.location.href = res.data
      }).catch(() => {
        this.$message({
          message: '导出详情失败',
          type: 'error'
        })
      }).finally(() => {
        this.exportDetailLoading = false
      })
    },
  },
}
</script>
<style scoped>
.meter-powerdata{
  --sharp-color: #FF4B5C;
  --peak-color: #FF8B3D;
  --flat-color: #FFC83D;
  --valley-color: #3ED598;
  --deepValley-color: #00C2FF;

  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-border-color);
}
.meter-powerdata >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-powerdata >>> .el-card__header .el-form-item{
  margin-bottom: 0;
}
.meter-powerdata >>> .el-card__header .el-form-item .el-date-editor{
  margin-top: 0;
}

.meter-powerdata >>> .el-card__header .el-form-item .el-input{
  width: 160px !important;
}
.meter-powerdata >>> .el-card__header .el-form-item:nth-child(5) .el-input{
  width: 200px !important;
}

.meter-powerdata >>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  box-sizing: border-box;
}
.meter-powerdata >>> .el-card__body .content-container{
  width: 100%;
  height: 100%;
  padding: 5px 15px;
  box-sizing: border-box;
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container{
  width: 100%;
  height: 70px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #162D60;
  border-radius: 10px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  align-items: center;
  justify-content: space-between;
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(1) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(1) .con{
  color: #ffffff;
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(2) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(2) .con{
  color: var(--sharp-color);
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(3) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(3) .con{
  color: var(--peak-color);
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(4) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(4) .con{
  color: var(--flat-color);
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(5) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(5) .con{
  color: var(--valley-color);
}
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(6) .head,
.meter-powerdata >>> .el-card__body .content-container .statistic-container .el-statistic:nth-child(6) .con{
  color: var(--deepValley-color);
}

.meter-powerdata >>> .el-card__body .content-container .result-container{
  width: 100%;
  height: calc(100% - 70px);
  padding: 0 0 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  align-items: center;
}
.meter-powerdata >>> .el-card__body .content-container .result-container .chart-container{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.meter-powerdata >>> .el-card__body .content-container .result-container .table-container{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

</style>
